import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Card, CardContent } from '@/components/ui/card';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { useLicenceDetailsForm } from '@/redux/post/usePostForm';
import ErrorMessage from '@/components/ErrorMessage';
import { ILicense } from '@/redux/post/post.d';
import LicenseDetailsCard from '@/pages/PostDetail/LicenseDetailsCard';
import {
  selectProjectEditorData,
  setProjectEditorData,
} from '@/redux/post/post.slice';

function LicenceDetails({ errors }: { errors: { [key: string]: string } }) {
  const dispatch = useDispatch();
  const projectEditorData = useSelector(selectProjectEditorData);
  const licenceDetailsForm = useLicenceDetailsForm(projectEditorData);

  const handleSelectChange = (name: string, value: string) => {
    dispatch(setProjectEditorData({ ...projectEditorData, [name]: value }));
  };

  const licenceTypeOptions = Object.values(ILicense);

  return (
    <div className="font-tertiary">
      <Card className="w-full max-w-6xl mx-auto">
        <CardContent className="p-4 sm:p-6">
          <Form {...licenceDetailsForm}>
            <form>
              <div className="space-y-6">
                <FormField
                  control={licenceDetailsForm.control}
                  name="licenceType"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-sm font-medium mb-2">
                        License Type
                      </FormLabel>
                      <FormControl>
                        <Select
                          options={licenceTypeOptions.map((option) => ({
                            label: option,
                            value: option,
                          }))}
                          onChange={(selectedOption) => {
                            if (selectedOption?.value) {
                              handleSelectChange(
                                field.name,
                                selectedOption.value
                              );
                            }
                          }}
                          isSearchable
                          name={field.name}
                          value={{
                            label: licenceTypeOptions.filter(
                              (model) => model === projectEditorData.licenceType
                            ) as unknown as string,
                            value: licenceTypeOptions.filter(
                              (model) => model === projectEditorData.licenceType
                            ) as unknown as string,
                          }}
                        />
                      </FormControl>
                      <ErrorMessage error={errors.licenceType} />
                    </FormItem>
                  )}
                />

                <LicenseDetailsCard post={projectEditorData} />
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}

export default LicenceDetails;
